<template>
  <input
    class="w-full grow rounded-md border border-border bg-transparent px-2.5 py-1.5 font-mono text-sm lowercase focus:outline focus:outline-2 focus:-outline-offset-1 focus:outline-blue-500"
    :value="draft"
    placeholder="#000000"
    @input="onInput"
    @change="onCommit"
  />
</template>

<script setup lang="ts">
import {
  type Hsl,
  convertHslToRgb,
  convertRgbToHsl,
  formatHex,
  parseHex,
} from "culori/fn";
import { ref, watch } from "vue";

const modelValue = defineModel<Hsl>({ required: true });

const draft = ref("");
let snapshot: string | undefined;

watch(
  modelValue,
  (hsl) => {
    const hex = formatHex(convertHslToRgb(hsl));
    if (hex === snapshot) {
      return;
    }

    snapshot = hex;
    draft.value = hex;
  },
  { immediate: true }
);

function onInput(event: Event) {
  const raw = (event.target as HTMLInputElement).value;
  draft.value = raw;

  const parsed = parseHex(raw);
  if (!parsed) {
    return;
  }

  const hex = formatHex(parsed);
  if (snapshot === hex) {
    return;
  }

  snapshot = hex;
  modelValue.value = convertRgbToHsl(parsed);
}

function onCommit(event: Event) {
  const raw = (event.target as HTMLInputElement).value;

  const parsed = parseHex(raw) ?? { mode: "rgb", r: 0, g: 0, b: 0 };
  const hex = formatHex(parsed);

  draft.value = hex;

  if (snapshot === hex) {
    return;
  }

  snapshot = hex;
  modelValue.value = convertRgbToHsl(parsed);
}
</script>
